import { Attribute, DateDisplay, Numeric, Percent, Space } from '@/components/core-v2'
import { PORTFOLIO_TYPE } from '@/constants'

import { ModelPortfolio } from '../../types'

type Props = {
  portfolio: ModelPortfolio
}

export const Details = ({ portfolio }: Props) => (
  <Space mb={0} mt={4} mx={2}>
    <Attribute name="Name">{portfolio.portfolioName}</Attribute>
    <Attribute name="Portfolio ID">{portfolio.portfolioId}</Attribute>
    <Attribute name="Type">{PORTFOLIO_TYPE[portfolio.type].value}</Attribute>
    <Attribute name="Rebalancing type">{portfolio.rebalancingDefinition?.type}</Attribute>
    {portfolio.rebalancingDefinition?.type === 'Frequency' && (
      <Attribute name="Rebalancing Frequency">
        {portfolio.rebalancingDefinition?.frequency}
      </Attribute>
    )}
    {portfolio.rebalancingDefinition?.type === 'Weight' && (
      <Attribute name="Rebalancing Tolerance">
        <Percent
          fixed
          highlightPnl={false}
          numDecimalPlaces={2}
          value={(portfolio.rebalancingDefinition?.weightsTolerance || 0) * 100}
        />
      </Attribute>
    )}
    <Attribute name="Tax classification">{portfolio.taxClassification}</Attribute>
    <Attribute name="Defined Multiplier">
      {!portfolio.multiplier ? 'Not specified' : <Numeric value={portfolio.multiplier} />}
    </Attribute>
    <Attribute name="Date created">
      <DateDisplay value={portfolio.dateAdded} />
    </Attribute>
    {portfolio.type === PORTFOLIO_TYPE.FundOfFunds.key && (
      <Attribute name="Start date">
        {'startDate' in portfolio && <DateDisplay value={portfolio?.startDate as string} />}
      </Attribute>
    )}
  </Space>
)
